module.exports = __webpack_public_path__ + "img/MX-B048047A-BS.561f4920.png";